export const FAVORITE_PRODUCTS_FACET_ID = 'favoriet';
